export default __webpack_public_path__ + "static/media/Coil of the Viper.2705422f.jpg";